import React from 'react';
import { useHerdsmanMessageForm } from '../hooks/useHerdsmanMessageForm';

export default function FormSendMessage(props) {
    const {
        triggerSubmit, setTriggerSubmit, onCloseModal, herdsman,
        onSubmitSendMessage
    } = props;

    const {
        register, handleSubmit, errors,
        buttonSubmitRef,
        onSubmit
    } = useHerdsmanMessageForm(herdsman, onSubmitSendMessage, onCloseModal, triggerSubmit, setTriggerSubmit);

    return (
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div className="row">
                <div className="form-group col-12">
                    <label><b>Nhắn tin đến: </b>{herdsman?.fullName}</label>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-12">
                    <label><b>Nội dung</b><span className='required'>*</span></label>
                    <textarea
                        rows="6"
                        className="form-control"
                        type="text"
                        name="content"
                        placeholder="Nội dung"
                        maxLength={1500}
                        ref={register({ required: true })}
                    />
                    {errors.content && (
                        <span className="error">Trường này là bắt buộc</span>
                    )}
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-12">
                    <label>Ảnh đính kèm</label>
                    <input
                        className="note-image-input form-control-file note-form-control note-input"
                        type="file"
                        name="Image"
                        ref={register()}
                        accept="image/*"
                    />
                </div>
            </div>

            <button ref={buttonSubmitRef} style={{ display: "none" }} type="submit" className="btn btn-primary">
                Lưu
            </button>
        </form>
    );
}
